// Adapter singleton: stores the active Yjs handle so store mutations can write to Yjs
// without creating a circular import (store → yjsAdapter ← graph-sync → store is fine).

export interface YjsHandle {
  upsertNode: (node: { id: string; [k: string]: unknown }) => void;
  removeNode: (id: string) => void;
  upsertLink: (link: { id: string; [k: string]: unknown }) => void;
  removeLink: (id: string) => void;
}

let _handle: YjsHandle | null = null;

export function setYjsHandle(h: YjsHandle | null) {
  _handle = h;
}

export function getYjsHandle(): YjsHandle | null {
  return _handle;
}
